import Vue from 'vue'
import VueRouter from 'vue-router'

import {
  firebaseAuth,
} from '../../firebase'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: () => import('@/views/cms/Dashboard.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/campaign/:slug',
      name: 'campaign',
      component: () => import('@/views/cms/campaign/Campaign.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/campaign/edit/:slug',
      name: 'edit-campaign',
      component: () => import('@/views/cms/campaign/CampaignEdit.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/views/cms/settings/AccountSetting.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/members',
      name: 'members',
      component: () => import('@/views/cms/Members.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/histories',
      name: 'histories',
      component: () => import('@/views/cms/Histories.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/coupons',
      name: 'coupons',
      component: () => import('@/views/cms/coupon/CouponList.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/pricing',
      name: 'pricing',
      component: () => import('@/views/cms/Pricing.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import('@/views/admin/Track.vue'),
      meta: {
        requiresAdmin: true,
        requiresAuth: true,
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/Register.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('@/views/ForgotPassword.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const requiresAdmin = to.matched.some(x => x.meta.requiresAdmin)

  if (requiresAuth && !firebaseAuth.currentUser) {
    next('/login')
  } else if (requiresAdmin) {
    firebaseAuth.currentUser.getIdTokenResult(true)
      .then(idTokenResult => {
        if (idTokenResult.claims.isAdmin) {
          next()
        } else {
          next('/')
        }
      })
      .catch(() => {
        next('/')
      })
  // eslint-disable-next-line no-else-return
  } else {
    next()
  }
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
